module.exports = {
  GetDataRequestType: {
    UpdateOnly: 0,
    SnapshotOnly: 1,
    SnapshotAndUpdate: 2,
    LastValueOnly: 3,
    LastValueAndUpdate: 4
  },
  SubscribeDatasetStatus: {
    Success: 0,
    Declined: 1
  },
  GetDataByRecordLocationRequestType: {
    FORWARD_EXCLUSIVE: 0,
    BACKWARD_EXCLUSIVE: 1,
    FORWARD_INCLUSIVE: 2,
    BACKWARD_INCLUSIVE: 3
  },
  SubscribeDatasetStatus: {
    SUCCESS: 0,
    DECLINED: 1,
    PENDING: 2
  },
  UnsubscribeDatasetStatus: {
    SUCCESS: 0,
    NOTSUBSCRIBED: 1
  },
  TSCalculateType: {
    AVG: 0,
    MIN: 1,
    MAX: 2,
    LAST: 3
  },
  WindowUnit: {
    SECOND: 0,
    MINUTE: 1,
    HOUR: 2,
    DAY: 3,
    WEEK: 4,
    MONTH: 5,
    YEAR: 6
  }

};


// WEBPACK FOOTER //
// ./src-client-lib/api/request/constants.js